

/**
 * This represents a single group of coinage (cp, sp, ep, gp, pp, etc).
 */
export class Money {
  platinum = 0;
  gold = 0;
  electrum = 0;
  silver = 0;
  copper = 0;

  constructor(obj?: any) {
    // this.type = obj ? obj.type : "cp";
    // this.count = obj ? obj.count : 0;
    
    if (obj) {
      if (obj.platinum !== undefined) {
        this.platinum = obj.platinum;
        this.gold = obj.gold;
        this.electrum = obj.electrum;
        this.silver = obj.silver;
        this.copper = obj.copper;
      } else if (obj.length > 0) {
        for (let i = 0; i < obj.length; i++) {
          switch (obj[i].type) {
            case "pp":
              this.platinum = +obj[i].count;
            break;
            case "gp":
              this.gold = +obj[i].count;
            break;
            case "ep":
              this.electrum = +obj[i].count;
            break;
            case "sp":
              this.silver = +obj[i].count;
            break;
            case "cp":
              this.copper = +obj[i].count;
            break;
          }
        }
      }
    }
  }

  toDBObj(): any {
    return {
      platinum: this.platinum,
      gold: this.gold,
      electrum: this.electrum,
      silver: this.silver,
      copper: this.copper
    };
  }

  gold_value(): number {
    return Math.round((this.platinum * 10 + this.gold + this.electrum / 2 + this.silver / 10 + this.copper / 100) * 100) / 100;
  }

  copyGoldValue(cost: number) { 
    this.gold = Math.floor(cost);
    cost = (cost - this.gold) * 10;
    this.silver = Math.floor(cost);
    this.copper = (cost - this.silver) * 10;
  }

  toString(): string {
    let str = "";
    if (this.platinum > 0) {
      str = `${this.platinum}pp `;
    }
    if (this.gold > 0) {
      str += `${this.gold}gp `;
    }
    if (this.electrum > 0) {
      str += `${this.electrum}ep `;
    }
    if (this.silver > 0) {
      str += `${this.silver}sp `;
    }
    if (this.copper > 0) {
      str += `${this.copper}cp `;
    }
    return str;
  }

  clone(): Money {
    const clone = new Money();
    clone.copy(this);
    return clone;
  }

  copy(copyMe: Money): void {
    this.platinum = copyMe.platinum;
    this.gold = copyMe.gold;
    this.electrum = copyMe.electrum;
    this.silver = copyMe.silver;
    this.copper = copyMe.copper;
  }

  add(copyMe: Money): void {
    this.platinum += copyMe.platinum;
    this.gold += copyMe.gold;
    this.electrum += copyMe.electrum;
    this.silver += copyMe.silver;
    this.copper += copyMe.copper;
  }

  subtract(copyMe: Money): void {
    this.platinum -= copyMe.platinum;
    if (this.platinum < 0) {
      this.gold += this.platinum * 10;
      this.platinum = 0;
    }
    this.gold -= copyMe.gold;
    if (this.gold < 0) {
      this.electrum += this.gold * 2;
      this.gold = 0;
    }
    this.electrum -= copyMe.electrum;
    if (this.electrum < 0) {
      this.silver += this.electrum * 5;
      this.electrum = 0;
    }
    this.silver -= copyMe.silver;
    if (this.silver < 0) {
      this.copper += this.silver * 10;
      this.silver = 0;
    }
    this.copper -= copyMe.copper;
  }
}